import { apiClient } from './client';
import type { PaginationParams, MessageResponse } from '../types/api';
import type {
  AdminAdminUserListResponse,
  AdminAdminUserDetail,
  AdminUserInviteRequest,
  AdminUserInviteResponse,
  AdminUserUpdateRequest,
  AdminUserSuspendRequest,
  AdminSessionRevokeRequest,
} from '../types/adminUsers';

export const adminUsersApi = {
  list: (params: PaginationParams & { role?: string; is_active?: boolean; search?: string }) =>
    apiClient.get<AdminAdminUserListResponse>('/admin-users', { params }).then((r) => r.data),

  detail: (id: string) =>
    apiClient.get<AdminAdminUserDetail>(`/admin-users/${id}`).then((r) => r.data),

  invite: (data: AdminUserInviteRequest) =>
    apiClient.post<AdminUserInviteResponse>('/admin-users/invite', data).then((r) => r.data),

  updateRole: (id: string, data: AdminUserUpdateRequest) =>
    apiClient.patch<MessageResponse>(`/admin-users/${id}`, data).then((r) => r.data),

  suspend: (id: string, data: AdminUserSuspendRequest) =>
    apiClient.post<MessageResponse>(`/admin-users/${id}/suspend`, data).then((r) => r.data),

  activate: (id: string) =>
    apiClient.post<MessageResponse>(`/admin-users/${id}/activate`).then((r) => r.data),

  remove: (id: string) =>
    apiClient.delete<MessageResponse>(`/admin-users/${id}`).then((r) => r.data),

  revokeSession: (adminId: string, sessionId: string, data: AdminSessionRevokeRequest) =>
    apiClient.post<MessageResponse>(`/admin-users/${adminId}/sessions/${sessionId}/revoke`, data).then((r) => r.data),
};
